import { Component, input, InputSignal } from '@angular/core';
import { IChatUser } from '../../models/chat';
import { TypingUsersLabelPipe } from '../../pipes/typing-users-label.pipe';

@Component({
	selector: 'ph-chat-typing-indicator',
	templateUrl: './ph-chat-typing-indicator.component.html',
	styleUrls: ['./ph-chat-typing-indicator.component.scss'],
	imports: [
		TypingUsersLabelPipe
	]
})
export class PhChatTypingIndicatorComponent {

	typingUsers: InputSignal<Array<IChatUser>> = input<Array<IChatUser>>([]);
}
